import { Outlet } from "react-router-dom";
import { Sidebar } from "./Sidebar";
import { SetupBanner } from "./SetupBanner";

export function Layout() {
  return (
    <div className="flex h-screen overflow-hidden">
      <Sidebar />
      <main className="flex-1 overflow-y-auto">
        <SetupBanner />
        <Outlet />
      </main>
    </div>
  );
}
